<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.path)">
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Others Info</v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submit"
                  ref="addEmployee"
                  id="addEmployee"
                >
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-date-input
                        label="Requisition Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="requisition_date.value.value"
                        :error-messages="requisition_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-date-input
                        label="Require Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="require_date.value.value"
                        :error-messages="require_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="warehouse_id.value.value"
                        :items="getWarehouseList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="warehouse_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Warehouse
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="department_id.value.value"
                        :items="getHrmDepartmentList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="department_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Department
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-text-field
                        label="Requisition By"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="requisition_by.value.value"
                        :error-messages="requisition_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="Requisition By Mobile"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="requisition_by_mobile.value.value"
                        :error-messages="requisition_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="Requisition By Email"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="requisition_by_email.value.value"
                        :error-messages="
                          requisition_by_email.errorMessage.value
                        "
                        :disabled="true"
                        autocomplete="off"
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Item Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submit"
                  ref="addEmployee"
                  id="addEmployee"
                >
                  <v-row class="pt-2 justify-center">
                    <v-col cols="8">
                      <v-autocomplete
                        :key="autocompleteKey"
                        label="Search Product Name"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="product_id.value.value"
                        :items="getProductMapList"
                        :item-title="(item) => `${item.product.name}`"
                        item-value="product_id"
                        :error-messages="product_id.errorMessage.value"
                        autocomplete="off"
                        @update:model-value="addCart"
                        @keydown.enter="addCart"
                        clearable
                      ></v-autocomplete>

                      <input
                        v-model="requisition_master_id.value.value"
                        type="hidden"
                      />
                    </v-col>

                    <v-col cols="1">
                      <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                    </v-col>
                  </v-row>

                  <!-- Cart Table -->
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <v-table
                        density="compact"
                        :loading="loading"
                        fixed-header
                        class="table-dotted-border-bottom"
                        style="height: 40vh; overflow-y: auto"
                      >
                        <thead>
                          <tr>
                            <th class="text-center">SL</th>
                            <th class="text-left" style="width: 30%">
                              Product Name
                            </th>
                            <th class="text-center" style="width: 25%">
                              Product Code
                            </th>
                            <!-- <th class="text-center" style="width: 15%">
                              Convert Qty
                            </th> -->
                            <th class="text-center" style="width: 20%">
                              Total Quantity
                            </th>
                            <!-- <th class="text-center" style="width: 15%">
                              Primary Qty
                            </th>
                            <th class="text-right" style="width: 15%">
                              Total Qty
                            </th> -->
                            <th class="text-center" style="width: 15%">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in cart"
                            v-if="cart.length > 0"
                            :key="index"
                          >
                            <td class="text-center py-1">{{ index + 1 }}</td>
                            <td
                              class="text-left py-1"
                              style="white-space: normal"
                            >
                              {{ item.product_name }}
                            </td>
                            <!-- <td class="text-right py-1">
                              <v-number-input
                                v-model="item.qty"
                                :reverse="false"
                                control-variant="stacked"
                                label=""
                                :hide-input="false"
                                :inset="false"
                                :min="1"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                :error-messages="
                                  item.qty < 1
                                    ? 'Quantity must be greater than 0'
                                    : ''
                                "
                                @update:model-value="updateItemTotals(item)"
                                @blur="updateItemTotals(item)"
                              />
                            </td> -->
                            <!-- <td class="text-center py-1">
                              {{ item.sec_unit_con_qty }}
                            </td> -->
                            <td class="text-center py-1">
                              {{ item.product_code }}
                            </td>
                            <td class="text-right py-1">
                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                label=""
                                type="number"
                                style="width: 80px;"
                                :hideInput="false"
                                :inset="false"
                                :min="0"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.primaryqty"
                                :error-messages="
                                  item.primaryqty < 0
                                    ? 'Quantity must be greater than 0'
                                    : ''
                                "
                              ></v-text-field>
                            </td>

                            <!-- Total Quantity (Primary + Converted Secondary) -->
                            <!-- <td class="text-center py-1">
                              {{ item.totalqty }}
                            </td> -->
                            <td class="text-center py-1">
                              <v-icon
                                size="small"
                                color="red"
                                class="delete-button"
                                @click="removeFromCart(index)"
                              >
                                mdi-delete
                              </v-icon>
                            </td>
                          </tr>

                          <tr v-else-if="loading == true">
                            <td colspan="6" class="text-center">
                              <v-skeleton-loader
                                type="heading"
                                :loading="loading"
                              />
                            </td>
                          </tr>
                          <tr v-else>
                            <td colspan="6" class="text-center text-red">
                              You have no item
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </v-col>
                  </v-row>
                  <!-- Close Cart Table -->

                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-row class="pt-2">
                      <v-col cols="8">
                        <v-textarea
                          label="Description"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="remarks.value.value"
                          :error-messages="remarks.errorMessage.value"
                          autocomplete="off"
                          rows="3"
                          clearable
                        ></v-textarea>
                      </v-col>
                      <v-col cols="4">
                        <v-layout class="justify-end">
                          <v-btn
                            class="bg-grey-darken-1 me-2"
                            variant="flat"
                            @click="submitForm(0)"
                            >DRAFT</v-btn
                          >
                          <v-btn
                            class="bg-primary"
                            variant="flat"
                            @click="submitForm(1)"
                            >POST</v-btn
                          >
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
export default {
  components: {},
  data: () => ({
    panel: [0],
    panel2: [0],
    loading: false,
    errorMessages: "",
    visible: false,
    search: "",
    selectedImage: null,
    photo_imageFile: "",
    preview: "/src/assets/no_preview.png",
    cart: [],
    autocompleteKey: 0,
  }),
  watch: {},
  created() {
    if (this.$store.getters.getHrmDepartmentList.length === 0) {
      this.$store.dispatch("getHrmDepartmentList");
    }
    if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    }
    if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    }
  },
  computed: {
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
        (item) =>
          item.branch_id == this.$store.getters.getAuthUser.branch_id &&
          item.status == 1
      );
    },
  },
  methods: {
    // addCart(){
    //         let cartInd = this.cart.findIndex(p => p.product_id == this.product_id.value.value);
    //         if(this.product_id.value.value == null){
    //         toast.error('Please select a Product');
    //             this.cartReset();
    //             return false;
    //         }
    //         if(cartInd > -1){
    //         toast.error('Product already added in cart');
    //             this.cartReset();
    //             return false;
    //         }

    //         let product = this.getProductMapList.find(item => item.id == this.product_id.value.value);
    //             product = product.product;

    //         let item = {
    //             product_id: this.product_id.value.value,
    //             product_name: product.name,
    //             qty: 1,
    //             unit_id: product.unit_id,
    //             unit_name: product.unit.name,
    //             sec_unit_con_qty:product.secondary_unit.conversion_qty,
    //             rate: product.purchase_rate,
    //             total: product.purchase_rate,
    //             // totalconvqty: qty * product.secondary_unit.conversion_qty,
    //         }

    //         this.cart.push(item);
    //         this.$nextTick(()=>{
    //             this.cartReset();
    //         })
    // },

    addCart() {
      const selectedProductId = this.product_id.value?.value;
      if (!selectedProductId) {
        toast.error("Please select a Product");
        this.cartReset();
        return false;
      }

      const cartInd = this.cart.findIndex(
        (p) => p.product_id === selectedProductId
      );
      if (cartInd > -1) {
        toast.error("Product already added in cart");
        this.cartReset();
        return false;
      }

      const productMap = this.getProductMapList.find(item => item.product_id == selectedProductId);
      const product = productMap?.product;
      const qty = 1;
      const primaryqty = 0;
      const secConv = product.secondary_unit.conversion_qty;

      const item = {
        product_id: selectedProductId,
        product_name: product.name,
        qty: qty,
        primaryqty: primaryqty,
        product_code:product.code,
        unit_id: product.unit_id,
        unit_name: product.unit.name,
        sec_unit_con_qty: secConv,
        rate: product.purchase_rate,
        total: product.purchase_rate,
        get totalconvqty() {
          return this.qty * this.sec_unit_con_qty;
        },
        get totalqty() {
          return this.totalconvqty + this.primaryqty;
        },
      };

      this.cart.push(item);
      this.$nextTick(() => {
        this.cartReset();
      });
    },

    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
    cartReset() {
      this.product_id.value.value = null;
      this.autocompleteKey++;
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        requisition_date: yup.date().required().label("Requisition Date"),
        require_date: yup.date().nullable().label("Require Date"),
        department_id: yup
          .number()
          .positive()
          .integer()
          .required()
          .label("Department Name"),
        warehouse_id: yup
          .number()
          .positive()
          .integer()
          .required()
          .label("Designation Name"),
      }),
    });

    const require_date = useField("require_date");
    const product_id = useField("product_id");
    const pr_status = useField("pr_status");
    const employee_id = useField("employee_id");
    const department_id = useField("department_id");
    const warehouse_id = useField("warehouse_id");
    const requisition_master_id = useField("requisition_master_id");
    const requisition_date = useField("requisition_date");
    const remarks = useField("remarks");
    const requisition_by = useField("requisition_by");
    const requisition_by_mobile = useField("requisition_by_mobile");
    const requisition_by_email = useField("requisition_by_email");
    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();
    const currentStatus = ref(0);
    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const submit = handleSubmit((values) => {
      values.status = currentStatus.value;
      values.cart = cart.value;
      values.requisition_date = formattedDate(requisition_date.value.value);
      values.require_date = formattedDate(require_date.value.value);

      store
        .dispatch("saveUpdatePurRequisition", values)
        .then((response) => {
          resetForm();
          buttonText.value = "Save";
          cart.value = [];
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "requisition-record" });
          }, 2000);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submitForm,
      submit,
      product_id,
      requisition_date,
      require_date,
      remarks,
      cart,
      requisition_by,
      requisition_by_mobile,
      requisition_by_email,
      pr_status,
      errorMessages,
      employee_id,
      department_id,
      warehouse_id,
      requisition_master_id,
      buttonText,
      loading,
    };
  },

  mounted() {
    this.pr_status.value.value = "1";
    this.employee_id.value.value = "";
    let user = this.$store.getters.getAuthUser;
    this.requisition_by.value.value = user.full_name;
    this.requisition_by_mobile.value.value = user.mobile;
    this.requisition_by_email.value.value = user.email;

    const id = this.$route.query.id;
    if (id) {
      this.$store.commit("SET_LOADING", { color: "primary" });

      this.$nextTick(() => {
        this.$store
          .dispatch("getPurRequisitionById", id)
          .then((data) => {
            this.isEntryMode = false;
            let requisition = data;
            this.requisition_master_id.value.value = requisition.id;
            this.requisition_date.value.value = requisition.requisition_date
              ? new Date(requisition.requisition_date)
              : new Date();
            this.require_date.value.value = requisition.require_date
              ? new Date(requisition.require_date)
              : new Date();
            this.warehouse_id.value.value = requisition.warehouse.id;
            this.department_id.value.value = requisition.department.id;
            this.product_id.value.value = null;
            this.cart.value = [];

            // Insert items one by one
            // Populate cart with computed quantities
            (requisition.requisition_details || []).forEach((item) => {
              const product = item.product || {};
              const secondary_unit = product.secondary_unit || {};
              const sec_unit_con_qty = secondary_unit.conversion_qty || 0;
              const qty = item.qty || 0;
              const primaryqty = item.primaryqty || 0;

              this.cart.push({
                product_id: item.product_id,
                product_name: product.name || "",
                product_code:product.code,
                qty: qty,
                primaryqty: primaryqty,
                unit_id: product.unit?.id || "",
                unit_name: product.unit?.name || "",
                sec_unit_con_qty: sec_unit_con_qty,
                rate: item.rate,
                total: qty * item.rate,
                get totalconvqty() {
                  return this.qty * this.sec_unit_con_qty;
                },
                get totalqty() {
                  return this.totalconvqty + this.primaryqty;
                },
              });
            });
            this.remarks.value.value = requisition.remarks
              ? requisition.remarks
              : "";
            this.$store.commit("UNSET_LOADING");
          })
          .catch((error) => {
            this.$store.commit("UNSET_LOADING");
            console.error("Failed to fetch requisition:", error);
          });
      });
    } else {
      this.requisition_master_id.value.value = "";
      this.requisition_date.value.value = new Date();
      this.require_date.value.value = new Date();
      this.isEntryMode = true;
    }
  },
};
</script>
